export const SectionCard = ({ title, icon: Icon, children }: any) => (
  <section className="rounded-2xl border border-gray-100 dark:border-white/10 bg-white dark:bg-[#111c44]/50 p-4 shadow-sm hover:shadow-md dark:hover:shadow-slate-950 transition-shadow">
    <h4 className="text-[11px] font-black text-gray-400 dark:text-slate-500 uppercase tracking-widest mb-4 flex items-center gap-2">
      <Icon size={13} />
      {title}
    </h4>
    <div className="space-y-3">{children}</div>
  </section>
);

interface DetailItemProps {
  label: string;
  value: string;
  icon: any;
  isEdit?: boolean;
  onChange?: (val: string) => void;
}

export const DetailItem = ({
  label,
  value,
  icon: Icon = false,
  isEdit,
  onChange,
}: DetailItemProps) => {
  return (
    <div
      className={`flex items-start gap-3 p-3 rounded-xl transition-colors ${
        isEdit
          ? "bg-white dark:bg-[#1b254b]/50 border border-blue-50 dark:border-white/10 shadow-sm"
          : "bg-gray-50 dark:bg-[#1b254b]/30"
      }`}
    >
      <div
        className={`p-2 rounded-lg border shrink-0 ${
          isEdit
            ? "bg-blue-50 dark:bg-blue-900/20 border-blue-100 dark:border-blue-900/30 text-blue-500 dark:text-blue-400"
            : "bg-white dark:bg-[#1b254b] border-gray-100 dark:border-white/5 text-gray-400 dark:text-slate-500"
        }`}
      >
        <Icon size={15} />
      </div>

      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-black text-gray-400 dark:text-slate-500 uppercase tracking-wider">
          {label}
        </p>

        {isEdit ? (
          <input
            type="text"
            value={value?.replace("%", "") || ""}
            onChange={(e) => onChange?.(e.target.value)}
            className="w-full bg-transparent border-none p-0 text-sm font-bold text-gray-900 dark:text-slate-100 focus:ring-0 focus:outline-none placeholder:text-gray-400 dark:placeholder:text-slate-600"
            placeholder={`Enter ${label}...`}
          />
        ) : (
          <p className="text-sm font-bold text-gray-900 dark:text-slate-200 wrap-break-word">
            {value || "N/A"}
          </p>
        )}
      </div>
    </div>
  );
};
